<mat-dialog-content class="mat-typography">
  <ng-container >
  <h1 mat-dialog-title class="dialog-header">{{"Licence Options" | translate}}</h1>
  <ng-template matStepLabel>Options</ng-template>
  <mat-divider style="margin-bottom: .5rem;"></mat-divider>
  <div class="flex OptionOrigin">
    <div>{{"Client" | translate}}: {{data.client.name}} </div>
    <div> | </div>
    <div>{{"Customer" | translate}}: {{ data.customer.name === 'UNKNOWN CUSTOMER' ? ('UNKNOWN CUSTOMER' | translate) : data.customer.name }}</div>
    <div> | </div>
    <div>{{"Licence" | translate}}: {{licence?.project}}</div>
    <div> | </div>
    <div>{{"LicenceType" | translate}}: {{licenceTypeName}}</div>
  </div>
  <mat-divider style="margin: .5rem 0;"></mat-divider>
  <app-mat-table-options [verify]="true"> </app-mat-table-options>

  <ng-container *ngIf="mergedLicences.length > 0">
    <mat-divider style="margin: .5rem 0;"></mat-divider>
    <h4>{{ "Enthält Bestellung" | translate }}</h4>
    <div class="merged-item">
      <mat-icon>description</mat-icon>
      <span><strong>AB-führend:</strong> {{ licence?.easybill_document_number || '–' }}</span>
    </div>
    <div *ngFor="let ml of mergedLicences" class="merged-item">
      <mat-icon>merge</mat-icon>
      <span><strong>AB-zugeordnet:</strong> {{ ml.document_number || ml.vrs }}</span>
      <button mat-flat-button color="accent" (click)="unmergeLicence(ml.guid)">{{ "Trennen" | translate }}</button>
    </div>
  </ng-container>
</ng-container>
<ng-container>
<button mat-flat-button
mat-dialog-close
cdkFocusInitial
color="primary"
class="float-right">OK</button>
</ng-container>
</mat-dialog-content>
